/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_PrevInputs */

const en_directory_external_directories_prev = /** @type {(inputs: Directory_External_Directories_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const zh_directory_external_directories_prev = /** @type {(inputs: Directory_External_Directories_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一页`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Directory_External_Directories_PrevInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_prev = /** @type {((inputs?: Directory_External_Directories_PrevInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_PrevInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_prev(inputs)
	return zh_directory_external_directories_prev(inputs)
});
export { directory_external_directories_prev as "directory.external_directories.prev" }